import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import centeredHeaderBg from '../images/about-us/headerBg.png';
// import headerRightBg375 from '../images/dashboard/headerRightBg375.png';
import PortraitNameTitle from '../components/PortraitNameTitle';
import navyTriangle from '../images/about-us/navyTriangle.png';
import blueTriangle from '../images/about-us/blueTriangle.png';
import harrai from '../images/about-us/harrai.jpg';
import gd from '../images/about-us/gd.jpg';
import jodha from '../images/about-us/jodha.jpg';
import jacob from '../images/about-us/jacob.jpg';
import khanh from '../images/about-us/khanh.jpg';
import tim from '../images/about-us/tim.jpg';
import jerome from '../images/about-us/jerome.jpg';
import wailing from '../images/about-us/wailing.jpg';
import landon from '../images/about-us/landon.jpg';
import jon from '../images/about-us/jon.jpg';
import james from '../images/about-us/james.jpg';
import diana from '../images/about-us/diana.jpg';

import { Link } from 'gatsby';
import AngleRight from '../components/AngleRight';
import groupChatting from '../images/about-us/groupChatting.jpg';

import BlogFeedItem from '../components/BlogFeedItem';
import bankbeatLogoBanner from '../images/news/bankbeat-logo-banner.png';
import aft from '../images/news/aft.png';
import Map from '../images/about-us/Map.svg';

const HeaderContent = styled.article`
	padding-bottom: 1em;
	display: flex;
	flex-direction: column;
	color: white;

	& h1 {
		min-height: 0;
	}

	& p {
		max-width: 520px;
	}
`;

const MessagingHeaderContent =
	<HeaderContent style={{marginTop: `0`, paddingTop: `15px`, paddingBottom: `20px`}}>
		<h1>We're Leveling<br />the Playing Field</h1>
		<p>MK is democratizing lending technology for financial institutions of all sizes. By facilitating borrowing and lending within communities, we strengthen local economies and help them thrive.</p>
	</HeaderContent>
;

const HeaderBottomContentFigure = styled.figure`

	& svg.bottomAligned {
		max-width: 85%;
		margin-bottom: 1em;

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 100%;
		}

		@media (${(props) => props.theme.largeUp}) {
			max-width: 484px;
		}

		@media (${(props) => props.theme.xLargeUp}) {
			max-width: 100%;
			margin-bottom: 2em;
		}
	}
`;

const PersonMessageBubblesFigure =
	<HeaderBottomContentFigure>
		{/* <PersonMessageBubbles alt='Person messaging on laptop' className='bottomAligned' /> */}
	</HeaderBottomContentFigure>
;

const Section = styled.section`

	& p,
	& q {
		line-height: 1.3;
	}

	& h2.blue {
		color: ${(props) => props.theme.lightBlue};
		margin: 0.5em 0 1em;
		font-size: 21px;
	}

	& .name {
		font-size: 26px;
		font-family: ${(props) => props.theme.headingFont};
	}

	& .job-title {
		text-transform: uppercase;
		font-size: 17px;
		font-family: ${(props) => props.theme.headingFont};
	}

	&.empowering-lenders {
		line-height: normal;
		text-align: left;

		& h2 {
			text-transform: none;
		}

		& p {
			font-weight: 600;
			font-family: ${(props) => props.theme.headingFont};
			font-size: 21px;
		}

		@media (${(props) => props.theme.mediumUp}) {
			text-align: center;

			& p {
				max-width: 32em;
				margin: 1em auto;
			}
		}
	}

	&.intro#FoundingTeam {

		@media (${(props) => props.theme.mediumUp}) {

			article {
				max-width: 55%;
			}
		}
	}

	&.profile {
		& .portrait {
			background-size: cover;
			background-repeat: no-repeat;
			text-align: center;
			min-width: 200px;
			min-height: 200px;

			@media (${(props) => props.theme.smallUp}) {
				// min-width: 406px;
				// min-height: 406px;
				max-width: 406px;
				max-height: 406px;
			}

			@media (${(props) => props.theme.smallUp}) and (-ms-high-contrast: none) {
				max-width: 300px;
			}

			@media (${(props) => props.theme.mediumUp}) {
				&.rightOnDesktop {
					order: 2;
				}
			}

			& img {
				margin: 10% 0;
				border-radius: 50%;
				width: 90%;
				max-width: 338px;
				max-height: 338px;
			}

			&.left {
				background-image: ${(props) => `url('${navyTriangle}')`};
				background-position: right top;
			}

			&.right {
				background-image: ${(props) => `url('${blueTriangle}')`};
				background-position: left top;
			}
		}

		& .bio {

			& h3 {
				margin-bottom: 0.5em;
			}

			&.leftOnDesktop {
				@media (${(props) => props.theme.mediumUp}) {
					padding-left: 0;
				}
			}

			& .job-title {
				font-family: ${(props) => props.theme.headingFont};
			}

			& q {
				font-family: ${(props) => props.theme.headingFont};
				color: ${(props) => props.theme.lightBlue};
				position: relative;
				padding-left: 80px;

				&:before {
					content: '“';
					font-size: 110px;
					font-weight: 600;
					line-height: 26px;
					left: 0;
					top: 30px;
					position: absolute;
				}
			}
		}
	}

	&.portraits {

		& h2 {
			text-align: center;

			@media (${(props) => props.theme.mediumUp}) {
				text-align: left;
			}
		}

		& h3 {
			margin-bottom: 0.5em;
		}

		& .three-portraits {
			display: flex;
			justify-content: space-between;
			flex-direction: column;

			@media (${(props) => props.theme.mediumUp}) {
				flex-direction: row;
			}
		}
	}

	&.teamPhotoBg {
		margin-top: 2em;
		margin-bottom: 4em;
		padding-bottom: 0;
		height: 399px;
		background-color: grey;
		background-image: ${(props) => `url('${groupChatting}')`};
		background-repeat: no-repeat;
		background-position: top center;
		color: white;
		text-align: center;
		display: flex;
		justify-content: center;
		align-self: center;

		& h2 {
			color: white;
		}

		& .careersPromo {
			display: flex;
			flex-direction: column;
			justify-content: center;

			& h2 {
				font-size: 30px;
			}

			& .primary-button {
				margin: 1em auto 0;
			}
		}
	}

	&.feed {
		margin-bottom: 2em;

		@media (${(props) => props.theme.mediumUp}) {

			& .intro {
				max-width: 50%;
			}

			& .articlesWrapper {
				justify-content: space-between;
				display: flex;
			}
		}
	}

	&.locations {

		& article {
			h2 {margin-top: 0;}
		}

		& figure {
			& svg {
				max-width: 408px;
				display: block;
				margin-left: auto;
				margin-right: auto;

				@media (${(props) => props.theme.largeUp}) {
					max-width: 528px;
				}
				@media (${(props) => props.theme.xLargeUp}) {
					max-width: 588px;
				}

			}
		}
	}
`;

const AboutUsPage = (props: any) => {
	return (
	<Layout
		// headerSplashBg375={headerRightBg375}
		headerSplashBgSize={'auto'}
		headerSplashBgPosition={'left top'}
		headerSplashBg={centeredHeaderBg}
		headerSplashBgSizeLarge={'auto'}
		headerSplashBgPositionLarge={'center center'}
		headerSplashAlignItemsLarge={'center'}
		headerContentClass={'company'}
		headerContent={MessagingHeaderContent}
		headerContentMaxWidth={'520px'}
		headerSplashBgAverageColor={'#fff'}
		pageTitle='Company'
		metaDescription={"We're on a mission to drive more lenders and borrowers online by providing exceptional lending technology to community financial institutions."}
		skipMoney2020={true}
		splashHeaderMinHeight={'448px'}
		BodyClass={'about-us'}
	>
		<div className='centeredWrapper'>
			<Section className='empowering-lenders centered-text'>
				<h2>Empowering Lenders Everywhere</h2>
				<p>MK is a financial technology company that supports community banks, credit unions, and finance companies with an intelligent loan origination system. MK works constantly to address the problems faced by lenders due to antiquated systems, cumbersome processes, and unresponsive interfaces.</p>
			</Section>
			<Section className='intro' id='FoundingTeam'>
				<article>
					<h2 className='blue'>MK's Founding Team</h2>
					<p>Established by brothers Har Rai and Guru Dharam Khalsa, MK is a family founded FinTech dedicated to serving communities with our lending platform. Together, the two have sought to build technology and transform the banking experience for both lenders and borrowers.</p>
				</article>
			</Section>
			<Section className='profile harrai row row-flush'>
				<figure className='portrait left col-12 col-md-4'>
					<img src={harrai} alt='Har Rai Khalsa' />
				</figure>
				<article className='bio col-12 col-md-7 offset-md-1'>
					<h3 className='name'>Har Rai Khalsa</h3>
					<h4 className='job-title'>Chief Executive Officer</h4>
					<p>As CEO, Har Rai Khalsa is leading MK to become the new standard in loan origination systems. His vision is to empower financial institutions and strengthen local economies through innovative banking technology.</p>
					<q>At MK, we see community financial institutions as the backbone of our national economy, which is why we’re committed to supporting them with our world-class technology and team.</q>
					<p>Prior to founding MK, Har Rai spent a number of years at Service Finance Company leading the growth team. With his expertise in sales and business development, the home improvement finance company increased its yearly loan volume from $97M to $2B. Har Rai holds a Bachelor of Arts in Sociology and Anthropology from Lewis and Clark College.</p>
				</article>
			</Section>
			<Section className='profile gd row row-flush'>
				<figure className='portrait right col-12 col-md-4 offset-md-1 rightOnDesktop'>
					<img src={gd} alt='Guru Dharam Khalsa' />
				</figure>
				<article className='bio col-12 col-md-7 leftOnDesktop'>
					<h3 className='name'>Guru Dharam Khalsa</h3>
					<h4 className='job-title'>Chief Operating Officer</h4>
					<p>As COO, Guru Dharam Khalsa leads MK’s Product Development and Software Engineering teams to provide financial institutions with high quality SaaS products. Guru Dharam is determined to bring user-friendly financial technology to the hands of customers worldwide.</p>
					<q>It’s exciting to be able to shape the future of lending and help financial institutions focus on building relationships with their customers.</q>
					<p>Guru Dharam's previous titles include CEO of 108 Solutions and Financial Analyst at Khalsa McBrearty Accountancy. During his time at 108 Solutions, Guru Dharam leveraged his 10+ years of experience in the finance industry to develop his first cloud-based loan origination platform. Guru Dharam holds a Bachelor of Applied Science in Entrepreneurship and Finance from Babson University.</p>
				</article>
			</Section>
			<Section className='profile jodha row row-flush'>
				<figure className='portrait left col-12 col-md-4'>
					<img src={jodha} alt='Har Rai Khalsa' />
				</figure>
				<article className='bio col-12 col-md-7 offset-md-1'>
					<h3 className='name'>Jodha Khalsa</h3>
					<h4 className='job-title'>Cheif Financial Officer</h4>
					<p>In his role as CFO, Jodha handles the accounting, financial modeling, and budgeting at MK. Jodha has over 35 years of professional services experience in tax preparation, tax reviews, and financial audits.</p>
					<q>The intersection of finance and technology is directly impacting consumers and businesses globally. At MK, we keep the end user at the heart of every product we build to ensure it creates the maximum impact.</q>
					<p>Jodha earned his Bachelor of Arts in Economics from Harvard University and holds a PhD in Accounting from Arizona State University. In 1984, he founded Khalsa McBrearty Accountancy, LLP and currently works with financial institution clients, such as Service Finance Company.</p>
				</article>
			</Section>
			<Section className='intro' id='LeadershipTeam'>
				<article>
					<h2 className='blue'>LEADERSHIP TEAM</h2>
					<p>Our team is driven by one common goal &mdash; to make lending simple. Passionate and strategic, MK’s leadership team inspires and guides our people to think outside the box and create incredible products.</p>
				</article>
			</Section>
			<Section className='portraits' id='Engineering'>
				<h2 className='blue'>Engineering</h2>
				<div className='three-portraits'>
					<PortraitNameTitle
						jpg={jacob}
						name={'Jacob Barnes'}
						jobTitle={'Software Engineer'}
					/>
					<PortraitNameTitle
						jpg={khanh}
						name={'Khanh Hoang'}
						jobTitle={'Lead UI Engineer'}
						url={'https://mkdecision.com/blog/2019/07/22/people-spotlight-khanh-hoang/'}
					/>
					<PortraitNameTitle
						jpg={tim}
						name={'Tim Petrone'}
						jobTitle={'Business System Engineer'}
						url={'https://mkdecision.com/blog/2019/04/08/employee-spotlight-tim-product-manager/'}
					/>
				</div>
			</Section>
			<Section className='portraits' id='Product'>
				<h2 className='blue'>Product</h2>
				<div className='three-portraits'>
					<PortraitNameTitle
						jpg={jerome}
						name={'Jerome Sheppard'}
						jobTitle={'Product Manager'}
						url={'https://mkdecision.com/blog/2019/03/12/employee-spotlight-jerome-sheppard/'}
					/>
					<PortraitNameTitle
						jpg={wailing}
						name={'Wai Ling Ye'}
						jobTitle={'Product Manager'}
						url={'https://mkdecision.com/blog/2019/10/17/people-spotlight-wai-ling-ye/'}
					/>
					<PortraitNameTitle
						jpg={landon}
						name={'John Landon'}
						jobTitle={'UX Designer'}
						url={'https://mkdecision.com/blog/2019/08/26/people-spotlight-john-landon-ux-engineer/'}
					/>
				</div>
			</Section>
			<Section className='portraits' id='Marketing'>
				<h2 className='blue'>Marketing</h2>
				<div className='three-portraits'>
					<PortraitNameTitle
						jpg={jon}
						name={'Jon BenAmoz'}
						jobTitle={'Chief Revenue Officer'}
						url={'https://mkdecision.com/blog/2020/01/15/people-spotlight-jon-benamoz/'}
					/>
					<PortraitNameTitle
						jpg={james}
						name={'James Bowles'}
						jobTitle={'Creative Lead'}
						url={'https://mkdecision.com/blog/2019/09/18/people-spotlight-james-bowles/'}
					/>
					<PortraitNameTitle
						jpg={diana}
						name={'Dianna Dunne-Vecchio'}
						jobTitle={'Communications Coordinator'}
					/>
				</div>
			</Section>
			<Section className='teamPhotoBg'>
				<article className='careersPromo'>
					<h2>Help us create the future of lending.</h2>
					<Link to='/careers/' className='primary-button animate-right cta careers-page-link'>See Life at MK<AngleRight /></Link>
				</article>
			</Section>
			<Section className='feed'>
				<h2 className='blue'>Newsroom</h2>
				<p className='intro'>The financial industry is taking notice; get the latest on MK Decision in one centralized place. With so much growth, you’ll want to stay informed.</p>
				<div className='articlesWrapper'>
					<BlogFeedItem
						nonMKLink={true}
						url={'https://www.businesswire.com/news/home/20191209005045/en/%C2%A0Four-Fintechs-Receive-Grants-Association-Financial-Technology'}
						backgroundImageURL={aft}
						postCategory={'Association for Financial Technology'}
						postTitle={'Four Fintechs Receive Grants from Association for Financial Technology (AFT)'}
						oneLiner={'AFT announces their inaugural Fintech Grant Program in partnership with ICBA. MK Decision, Adlumin, Botdoc, and Teslar Software are the four proud recipients of this grant.'}
					/>
					<BlogFeedItem
						nonMKLink={true}
						url={'https://bankbeat.biz/payments-guru-mentors-and-inspires/'}
						backgroundImageURL={bankbeatLogoBanner}
						postCategory={'BankBeat'}
						postTitle={'Payments guru mentors and inspires'}
						oneLiner={'Tina Giorgio, ICBA Bancard president and CEO, shares her background in payments, her role models, and how her dedication to mentoring others, including MK Decision, has fostered valuable and long-lasting relationships.'}
					/>
				</div>
			</Section>
			<Section className='locations row row-flush'>
				<article className='col-12 col-md-4'>
				<h2 className='blue'>MK Around the Nation</h2>
					<p>Headquartered in San Diego, with offices in Phoenix, AZ and Fort Lauderdale, FL, MK Decision aims to service financial institutions all over the country.</p>
				</article>
				<figure className='col-12 col-md-8'>
					<Map alt='MK US Locations' />
				</figure>

			</Section>
		</div>
	</Layout>
	);
};

export default AboutUsPage;
